import {isSecondaryManual} from './componentManualLauncherAssembly'
// Â© 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
import { Path, PlaneGeometry, Shape, ShapeGeometry, type BufferGeometry } from 'three'
import type { MachineDevice } from '@core/machine'
import {isScoopKicker} from './componentKickerPresentation'
import {manufacturedScoopRadius} from './componentKickerGeometry'
type DeckFactory=(width:number,length:number,devices:readonly MachineDevice[],scoops:boolean)=>BufferGeometry
let componentDeck:DeckFactory|undefined
export function registerScoopDeckFactory(factory:DeckFactory):void {componentDeck=factory}
/** New-table apertures use the actual holding-scoop regions; legacy quad remains exact. */
export function scoopDeck(width: number, length: number, devices: readonly MachineDevice[], pierced: boolean): BufferGeometry {
  if(componentDeck!==undefined)return componentDeck(width,length,devices,pierced)
  if (!pierced) return new PlaneGeometry(width, length)
  const shape = new Shape()
  shape.moveTo(-width/2,-length/2); shape.lineTo(width/2,-length/2)
  shape.lineTo(width/2,length/2); shape.lineTo(-width/2,length/2); shape.closePath()
  for (const d of devices) if (d.kind === 'kicker' && isScoopKicker(d)) {
    const hole = new Path(); hole.absarc(d.centre[0],d.centre[1],(manufacturedScoopRadius(d.captureRadius)+.0032),0,Math.PI*2,true)
    shape.holes.push(hole)
  }
  const geometry = new ShapeGeometry(shape,16)
  const positions = geometry.getAttribute('position'), uv = geometry.getAttribute('uv')
  for (let i=0;i<positions.count;i++) uv.setXY(i,positions.getX(i)/width+.5,positions.getY(i)/length+.5)
  return geometry
}

/** A geometry key excludes ordinary component/rule edits. */
export function scoopDeckKey(devices:readonly MachineDevice[]):string{return JSON.stringify(devices.flatMap(d=>(d.kind==='autoPlunger'||isSecondaryManual(d,devices))?[['auto',...d.centre,...d.exit.direction]]:d.kind==='dropTarget'?[['target',...d.a,...d.b]]:d.kind==='kicker'&&isScoopKicker(d)?[['scoop',...d.centre,(manufacturedScoopRadius(d.captureRadius)+.0032)]]:[]))}
